module.exports = __webpack_public_path__ + "img/adobe-xd.57cc3821.svg";